module Shared {
    export class VatScheme {
        static none: string = "_blank_";
        static flatRate: string = "FRV";
        static nonFlatRate: string = "Non_FRV";
    }
}
